import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'signin-sign_up_modal_private_policy-click';

/**
 * This will record when the "private policy" link is clicked on sign up modal: https://www.faire.com/en-ca/privacy
 */
export function trackSigninSignUpModalPrivatePolicyClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
